import { FormattedMessage } from 'react-intl'
import CookieConsent from "react-cookie-consent"
import { Fragment, useState } from "react"

const CookieBanner = () => {

    return (
   <Fragment>
  <div>

  <CookieConsent
  style={{
    background: "rgba(0, 0, 0, 0.6)"
  }}
  buttonText="ACCEPT"
  buttonStyle={{
    background: "#006400",
    color: "white",
    fontWeight: "bolder",
    textShadow: "1px 1px black"
  }}
  expires={90}
  enableDeclineButton
  declineButtonText="REJECT"
  declineButtonStyle={{
    background: "#FF0000",
    color: "white",
    fontWeight: "bolder",
    textShadow: "1px 1px black",
    marginLeft: "10px",
    border: "none",
    cursor: "pointer"
  }}
 
>
  <div>
    <FormattedMessage id='This website uses cookies to improve your experience and provide you with the best possible service. Please click Accept. You can learn more about our use of cookies.' />&nbsp;
    <a style={{ color: '#F8F8FF' }} href="https://biccorporation.co.th/cookie-policy/" target="_blank">
      <u><FormattedMessage id='Cookie Policy' /></u>
    </a>    
  </div>
  <div>
    <FormattedMessage id='If you wish to withdraw your consent, you can download the consent form at' />&nbsp;
     <a style={{ color: '#F8F8FF' }} href="https://drive.google.com/uc?export=download&amp;id=1xpyHXKpkZIQp6JizsscFKLU1g_fVUw8_" target="_blank">
      <u><FormattedMessage id='Data Subject Rights request form' /></u>
    </a>
  </div>
</CookieConsent>


  </div>
</Fragment>

    )
}

export default CookieBanner